import axios from 'axios'
import moment from 'moment'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const fetchAccountStatusList = (data: any) => {
  const params = {
    ...data,
    from_date: data?.fromDate && moment(data?.fromDate).format('YYYY-MM-DD'),
    to_date: data?.toDate && moment(data?.toDate).format('YYYY-MM-DD'),
  }
  delete params?.fromDate
  delete params?.toDate
  return axios.get(`${API_URL}/case-reports`, {
    params,
  })
}
// axios.get(`${API_URL}/account-status/${params?.module_name}`, {params})
